var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-map',{staticStyle:{"height":"1000px","width":"100%"},attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":{zoomControl: false,
    attributionControl:false,
    dragging: true,
    scrollWheelZoom:false,
    zoomSnap:0.1,
    doubleClickZoom:false,
    touchZoom:false}}},[_vm._l((_vm.markers),function(marker){return _c('l-marker',{key:marker.uid,attrs:{"lat-lng":marker.position,"icon":_vm.icon}})}),(_vm.show)?_c('l-geo-json',{attrs:{"geojson":_vm.geojson,"options-style":_vm.styleFunction}}):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }